import React from 'react';

import { Button } from 'react-bootstrap';

export default React.forwardRef(({ value, onClick }, ref) => (
    <Button variant="secondary" block onClick={onClick}>
        {value}
    </Button>
));